import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  TextField,
  Autocomplete,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import ImgHabitModal from "../../../../../assets/Images/CarePlan4.jpg";
import habitsDataJson from '../../../../../utils/Apis/ApisJson/habits.json';

export default function AddHabitModal({ open, onClose, onSave }) {
  const { t } = useTranslation();
  const [selectedHabit, setSelectedHabit] = useState(null);

  const habitOptions = habitsDataJson.map((habit) => ({
    label: habit.habit,
  }));

  const handleSave = () => {
    if (selectedHabit) {
      onSave({
        id: Date.now(),
        date: new Date().toLocaleDateString(),
        name: selectedHabit.label,
        status: "Activo",
      });
      onClose();
      setSelectedHabit(null);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 450,
          bgcolor: "white",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          textAlign: "center",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            color: "#085394",
            mb: 2,
            textTransform: "uppercase",
          }}
        >
          {t("CarePlan.habit.modal.title")}
        </Typography>

        <Autocomplete
          options={habitOptions}
          getOptionLabel={(option) => option.label}
          value={selectedHabit}
          onChange={(event, newValue) => setSelectedHabit(newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("CarePlan.habit.modal.search")}
              variant="outlined"
              fullWidth
              sx={{ mb: 2 }}
            />
          )}
        />

        <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
          <img
            src={ImgHabitModal}
            alt="Hábito"
            style={{
              width: "80%",
              maxWidth: "300px",
              opacity: 0.8,
              borderRadius: "8px",
            }}
          />
        </Box>

        <Button
          variant="contained"
          color="success"
          fullWidth
          onClick={handleSave}
          disabled={!selectedHabit}
        >
          {t("common.save")}
        </Button>
      </Box>
    </Modal>
  );
}
